import './UserMenu.scss';
import { useEffect, useState } from 'react';
import userSettingIcon from './img/user-setting-icon.png';
import orderHistoryIcon from './img/order-history-icon.png';
import paymentIcon from './img/payment-con.png';
import notificationsIcon from './img/notication-icon.png';
import privacyPolicyIcon from './img/privacy-policay.png';
import learnMoreIcon from './img/learn-more.png';
import logoutIcon from './img/log-out-icon.png';

export default function UserMenu({
  userName = 'User',
  userIconSrc,
  arrowIconSrc,
  disabled = false,
  onAccountSettings,
  onOrderHistory,
  onPayment,
  onNotifications,
  onPrivacyPolicy,
  onLearnMore,
  onLogout,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
      return;
    }
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const onPointerDown = (e) => {
      if (!e.target?.closest?.('.user-menu')) setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('pointerdown', onPointerDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('pointerdown', onPointerDown);
    };
  }, [open, disabled]);

  return (
    <div className={`user-menu ${open ? 'user-menu--open' : ''}`}>
      <button
        type="button"
        className="user-menu__trigger"
        onClick={() => {
          if (disabled) return;
          setOpen((v) => !v);
        }}
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
      >
        {!!userIconSrc && <img src={userIconSrc} alt="user" className="user-menu__icon" />}
        <span className="user-menu__name">{userName}</span>
        {!disabled && !!arrowIconSrc && (
          <img src={arrowIconSrc} alt="" className="user-menu__arrow" />
        )}
      </button>

      {!disabled && open && (
        <div className="user-menu__dropdown" role="menu" aria-label="User menu">
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onAccountSettings}>
            <img className="user-menu__item-icon" src={userSettingIcon} alt="" aria-hidden="true" />
            Account Settings
          </button>
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onOrderHistory}>
            <img className="user-menu__item-icon" src={orderHistoryIcon} alt="" aria-hidden="true" />
            Order History
          </button>
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onPayment}>
            <img className="user-menu__item-icon" src={paymentIcon} alt="" aria-hidden="true" />
            Payment
          </button>
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onNotifications}>
            <img className="user-menu__item-icon" src={notificationsIcon} alt="" aria-hidden="true" />
            Notifications
          </button>
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onPrivacyPolicy}>
            <img className="user-menu__item-icon" src={privacyPolicyIcon} alt="" aria-hidden="true" />
            Privacy Policy
          </button>
          <button type="button" className="user-menu__item user-menu__item--link" role="menuitem" onClick={onLearnMore}>
            <img className="user-menu__item-icon" src={learnMoreIcon} alt="" aria-hidden="true" />
            Learn More
          </button>

          <div className="user-menu__divider" />

          <button type="button" className="user-menu__logout" role="menuitem" onClick={onLogout}>
            <img className="user-menu__logout-icon" src={logoutIcon} alt="" aria-hidden="true" />
            Log Out
          </button>
        </div>
      )}
    </div>
  );
}

